// A rater's "take your own" referral (?ref=<their rater link code>), kept on this device for
// 60 days. A rater who taps the invitation but starts later (another visit, no ?ref) still
// counts as referred by that link. Used once: cleared when a take starts with it. Storage can
// be missing or blocked (private mode), so every access is guarded.

const KEY = "gp_ref";
const KEEP_MS = 60 * 24 * 3600_000;

export function rememberReferral(code: string, now = Date.now()): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, at: now }));
  } catch {
    // Storage blocked: the ?ref in the address still works this visit.
  }
}

export function recalledReferral(pattern: RegExp, now = Date.now()): string | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;
    const { code, at } = JSON.parse(raw) as { code?: unknown; at?: unknown };
    if (typeof code !== "string" || typeof at !== "number" || !pattern.test(code) || now - at > KEEP_MS) return undefined;
    return code;
  } catch {
    return undefined;
  }
}

export function forgetReferral(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing kept.
  }
}
